type Props = {
    size?: number;
    style?: React.CSSProperties;
    title?: string;
};

// Map-pin holding a sun-rise-over-mountains scene. The teal fill is
// `currentColor` so it inherits from CSS context (e.g.
// `style={{ color: "var(--gt-primary)" }}`); the white sky and the orange
// sun are intentionally fixed.
const PlanamotoMark: React.FC<Props> = ({ size = 28, style, title }) => (
    <svg
        viewBox="0 0 64 64"
        width={size}
        height={size}
        style={style}
        role={title ? "img" : "presentation"}
        aria-label={title}
        aria-hidden={title ? undefined : true}
    >
        <path d="M 32 60 L 14 40 A 22 22 0 1 1 50 40 Z" fill="#0f4c5c" stroke="#ffffff" strokeWidth={1}/>

        <circle cx="32" cy="26" r="16" fill="#ffffff"/>
        <circle cx="32" cy="26" r="10" fill="#f08020"/>
        <path d="M 13 37 L 20 28 L 25 30 L 31 20 L 37 28 L 42 24 L 46 30 L 49 39 L 30 50 Z" fill="#0f4c5c"/>

    </svg>
);

export default PlanamotoMark;
